import unionPayApi from '@/api/unionPay';
import loadScript from '@/utils/loadScript';

const UNI_PAY_APP_SDK = 'https://open.95516.com/s/open/js/upsdk.js';
const UNI_PAY_APP_SDK_CONFIG_KEY = 'UNI_PAY_APP_SDK_CONFIG_KEY';
const UNI_PAY_APP = 'H000020230001';

const cacheSrv = new Map();

let response = null;

let configPromise = null;

async function configUniPayApp() {
  if (configPromise) {
    return configPromise;
  }

  if (!window.upsdk) {
    await loadScript(UNI_PAY_APP_SDK);
  }

  // eslint-disable-next-line no-async-promise-executor
  configPromise = new Promise(async (resolve, reject) => {
    const url = window.location.href;
    if (!response) {
      try {
        response = await unionPayApi.getUniPayAppSign(url);
      } catch {
        reject(new Error('获取云闪付签名失败'));
      }
    }
    if (response) {
      console.info('config unipay--config value', {
        appId: response.appId || UNI_PAY_APP,
        timestamp: response.timestamp,
        nonceStr: response.nonceStr,
        signature: response.signature,
      });
      window.upsdk.config({
        debug: false,
        appId: response.appId || UNI_PAY_APP,
        timestamp: response.timestamp,
        nonceStr: response.nonceStr,
        signature: response.signature,
      });
    }

    window.upsdk.ready(() => {
      console.info('config unipay ready', window.upsdk);
      if (response) {
        cacheSrv.set(UNI_PAY_APP_SDK_CONFIG_KEY, {
          appId: response.appId || UNI_PAY_APP,
          timestamp: response.timestamp,
          nonceStr: response.nonceStr,
          signature: response.signature,
        });
      }
      resolve(window.upsdk);
    });

    window.upsdk.error((res) => {
      // eslint-disable-next-line no-console
      console.error('config unipay failed', res);
      reject(new Error(`配置云闪付异常, ${res.errMsg}`));
    });
  });

  return configPromise;
}


const unionPay = {
  async closeWebView() {
    await configUniPayApp();
    window.upsdk.closeWebApp();
  },
  async getCachedUniPayAppConfig() {
    await configUniPayApp();
    return cacheSrv.get(UNI_PAY_APP_SDK_CONFIG_KEY);
  },
};

export default unionPay;
